import _jsx2 from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _PageSidebar, _PageFooter;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useCallback, useMemo, memo } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Page from 'components/Page';
import PageInner from 'components/PageInner';
import PageContent from 'components/PageContent';
import PageSidebar from 'components/PageSidebar';
import LayoutContainer from 'components/LayoutContainer';
import BankCardItem from 'components/BankCardItem';
import BankCardListLoader from 'components/BankCardListLoader';
import OrganizationPageHeader from 'components/OrganizationPageHeader';
import NoData from 'components/NoData';
import PageFooter from 'components/PageFooter';
import { useSelectorProps } from 'hooks';
import { fetchProductsByFilters } from 'actions';
import { getCompanyWithProducts, getProductsIsLoaded, getProductsIsRequestFailed, getOrganizationIsRequestFailed, getProductsIsFetching } from 'selectors';
import { TextCountWrapper, TextCount } from 'components/ProductsList/styles';
import { ListWrapper, ProductsWrapper } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function OrganizationPage(_ref) {
  var loadData = _ref.loadData,
      staticContext = _ref.staticContext;
  var selectorProps = useSelectorProps();
  var history = useHistory();
  var dispatch = useDispatch();
  var isLoaded = useSelector(function (state) {
    return getProductsIsLoaded(state, selectorProps);
  });
  var isFetching = useSelector(function (state) {
    return getProductsIsFetching(state, selectorProps);
  });
  var productaIsRequestFailed = useSelector(function (state) {
    return getProductsIsRequestFailed(state, selectorProps);
  });
  var organizationIsRequestFailed = useSelector(function (state) {
    return getOrganizationIsRequestFailed(state, selectorProps);
  });
  var isErrPage = useMemo(function () {
    return productaIsRequestFailed || organizationIsRequestFailed;
  }, [productaIsRequestFailed, organizationIsRequestFailed]);
  var visible = useSelector(function (state) {
    return getCompanyWithProducts(state, selectorProps);
  });
  var productsCount = useMemo(function () {
    return visible.products.length;
  }, [visible]);
  var handleFetchProducts = useCallback(function () {
    dispatch(fetchProductsByFilters(selectorProps));
  }, [dispatch, selectorProps]);
  var handleResetFilters = useCallback(function () {
    history.push({
      pathname: '/'
    });
  }, []);
  useEffect(function () {
    loadData(dispatch, selectorProps);
    window.scrollTo(0, 0);
  }, []);

  if (isErrPage && staticContext) {
    staticContext.status = 404;
  }

  return /*#__PURE__*/_jsx2(Page, {}, void 0, /*#__PURE__*/_jsx2(LayoutContainer, {}, void 0, /*#__PURE__*/_jsx2(PageInner, {}, void 0, /*#__PURE__*/_jsx2(PageContent, {}, void 0, isLoaded && /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OrganizationPageHeader, _objectSpread({}, visible)), /*#__PURE__*/_jsx2(TextCountWrapper, {}, void 0, /*#__PURE__*/_jsx2(TextCount, {}, void 0, /*#__PURE__*/_jsx2(FormattedMessage, {
      id: "cardsListHeader.count",
      values: {
        count: productsCount
      }
    }))), /*#__PURE__*/_jsx2(ProductsWrapper, {}, void 0, visible.products.map(function (item) {
      return /*#__PURE__*/_jsx2(ListWrapper, {}, item.id, /*#__PURE__*/_jsx2(BankCardItem, {
        card: item
      }));
    }))]
  }), isFetching && Array.from(Array(6)).map(function (_, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _jsx2(BankCardListLoader, {
        hideCompanyDetails: true
      }, index)
    );
  }), (isErrPage || !productsCount && isLoaded) && /*#__PURE__*/_jsx2(NoData, {
    isRequestField: isErrPage,
    fetchData: handleFetchProducts,
    resetFilters: handleResetFilters
  })), _PageSidebar || (_PageSidebar = /*#__PURE__*/_jsx2(PageSidebar, {}))), _PageFooter || (_PageFooter = /*#__PURE__*/_jsx2(PageFooter, {}))));
}

OrganizationPage.defaultProps = {
  staticContext: null
};
export default withRouter( /*#__PURE__*/memo(OrganizationPage));